class CartInventorySync extends HTMLElement {
  static desiredValue = null;
  static persistedValue = null;
  static requestInFlight = false;
  static retryAttempt = 0;
  static retryTimer = null;

  connectedCallback() {
    const desiredValue = this.dataset.outOfStock === 'true' ? 'true' : 'false';
    const currentValue =
      this.dataset.currentValue === 'true'
        ? 'true'
        : this.dataset.currentValue === 'false'
          ? 'false'
          : null;

    if (CartInventorySync.desiredValue !== desiredValue) {
      CartInventorySync.retryAttempt = 0;
      clearTimeout(CartInventorySync.retryTimer);
    }

    CartInventorySync.desiredValue = desiredValue;
    CartInventorySync.persistedValue = currentValue;
    CartInventorySync.setCheckoutPending(
      CartInventorySync.requestInFlight || desiredValue !== currentValue
    );
    CartInventorySync.flush();
  }

  static async flush() {
    if (CartInventorySync.requestInFlight) return;
    if (CartInventorySync.desiredValue === CartInventorySync.persistedValue) {
      CartInventorySync.setCheckoutPending(false);
      return;
    }

    CartInventorySync.requestInFlight = true;
    CartInventorySync.setCheckoutPending(true);

    try {
      while (CartInventorySync.desiredValue !== CartInventorySync.persistedValue) {
        const valueToPersist = CartInventorySync.desiredValue;
        const response = await fetch(window.routes?.cart_update_url || '/cart/update.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            attributes: {
              _out_of_stock_cart: valueToPersist,
            },
          }),
        });

        if (!response.ok) {
          throw new Error(`Cart attribute update failed with status ${response.status}`);
        }

        const cart = await response.json();
        CartInventorySync.persistedValue =
          cart.attributes?._out_of_stock_cart === 'true' ? 'true' : 'false';

        document.querySelectorAll('cart-inventory-sync').forEach((element) => {
          element.dataset.currentValue = CartInventorySync.persistedValue;
        });
      }

      CartInventorySync.retryAttempt = 0;
    } catch (error) {
      console.error('Unable to synchronize cart inventory status.', error);
    } finally {
      CartInventorySync.requestInFlight = false;

      if (CartInventorySync.desiredValue !== CartInventorySync.persistedValue) {
        CartInventorySync.setCheckoutPending(true);
        CartInventorySync.retryAttempt += 1;
        clearTimeout(CartInventorySync.retryTimer);
        CartInventorySync.retryTimer = setTimeout(
          () => CartInventorySync.flush(),
          Math.min(1000 * 2 ** (CartInventorySync.retryAttempt - 1), 10000)
        );
      } else {
        CartInventorySync.setCheckoutPending(false);
      }
    }
  }

  static setCheckoutPending(isPending) {
    document.querySelectorAll('[name="checkout"]').forEach((button) => {
      if (isPending) {
        if (!button.disabled) {
          button.disabled = true;
          button.dataset.inventorySyncDisabled = 'true';
        }
        return;
      }

      if (button.dataset.inventorySyncDisabled === 'true') {
        button.disabled = false;
        delete button.dataset.inventorySyncDisabled;
      }
    });

    document.querySelectorAll('.cart__dynamic-checkout-buttons').forEach((container) => {
      if (isPending) {
        if (!container.inert) {
          container.inert = true;
          container.dataset.inventorySyncInert = 'true';
        }
        return;
      }

      if (container.dataset.inventorySyncInert === 'true') {
        container.inert = false;
        delete container.dataset.inventorySyncInert;
      }
    });
  }
}

if (!customElements.get('cart-inventory-sync')) {
  customElements.define('cart-inventory-sync', CartInventorySync);
}
